<template>
    <div class="participant-profile mt-page mb-3">

        <data-form :title="$i18n.gt('HEADING_MY_PROFILE')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="participantFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('MESSAGE_PROFILE_UPDATED')"
                   :submit-error-message="$i18n.gt('MESSAGE_PROFILE_ERROR')"
                   submit-success-route="/"
                   cancel-route="/">
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import ParticipantFields from '@/models/Participant'
import PatientPageMixin from '@/providers/PatientPageMixin'

/**
 * Page for a Participant to edit their profile
 */
export default Vue.extend({
    name: 'ParticipantProfile',
    mixins: [PatientPageMixin],
    props: {
        participantId: Number
    },
    data() {
        return {
            participantFields: ParticipantFields,
        }
    },
    computed: {
        fieldGroups() {
            if (this.$user.practitionerId() && !this.$user.isPractitionerMaskingAsSelf()) {
                return [
                    ['email'],
                    ['firstname', 'lastname'],
                ]
            } else {
                return [
                    ['firstname', 'lastname', 'dob', 'gender', 'gender_identity', 'pronouns', 'sexual_orientation', 'ethnicity'],
                    ['email', 'phone_primary', 'phone_secondary', 'contact_privacy_waived', 'preferred_contact_method'],
                    ['external_id', 'emr_id', 'address', 'address2', 'city', 'state', 'zip'],
                ]
            }
        }

    },
    methods: {
        loadModelInstance() {
            return this.$api.getItem(this, 'participant', this.participantId)

        },
        async onSubmit(modelInstance) {
            await this.$api.updateItem(this, 'participant', modelInstance)
            this.loadParticipant(true) // clear "please update your profile" message
        }
    }
})

</script>
